import {
  Component,
  OnInit,
  Inject,
  ViewChild,
} from "@angular/core";
import { FieldFormService } from "../../services/forms/field-form.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MapService } from "../../../view/services/map.service";
import { PanoramicService } from "../../../view/services/panoramic.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource, MatTable } from "@angular/material/table";
import { FilterService } from "../../services/filter/filter.service";

@Component({
  selector: "app-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.css"],
})
export class FilterComponent implements OnInit {
  fields: any;
  formId: any;
  campoId: any;
  tipoBuscar: any;
  valorBuscar: any;
  valorBuscar2: any;
  campos: any = [];
  activos: any = [];
  camposigual: any = [];
  resultados: string[] = [];
  resultadosCampos: any = [];
  resultadosActivos: any = [];
  displayedColumns: string[] = [];
  DATOS_RESULTADOS: VistaResultados[] = [];
  defCampo1: String;
  defCampo2: String;
  loading = false;
  pagination = true;
  pagslength = 0;
  dataSource = new MatTableDataSource<VistaResultados>([]);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('table', { static: true }) table: MatTable<Element>;

  constructor(
    protected mapService: MapService,
    protected filterService: FilterService,
    protected fieldFormService: FieldFormService,
    protected panoramicService: PanoramicService,
    private dialogRef: MatDialogRef<FilterComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formId = mapService.getCurrentFormId();

    //RE PLANTEAR (Por Coordenadas)
    /*      if (this.formId === "") {
            this.dialogRef.close();
            alert(
              "No se ha seleccionado ningún formulario para realizar la busqueda"
            );
          }  */

    this.fieldFormService
      .getFieldForm({ formulario_id: this.formId })
      .subscribe((data: {}) => {
        this.fields = data["SDTFormularioid"];
      });
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
  }

  cargarEscena(name, x, y) {
    var xmlscene = name.substring(6, 16);
    this.panoramicService.loadScene(xmlscene, name);
    this.panoramicService.getPanoramic().call("lookat(" + x + "," + y + ")");
    this.dialogRef.close();
  }

  limpiar() {
    if (this.resultados.length != 0) {
      this.resultados = [];
      this.campos = [];
      this.resultadosCampos = [];
      this.resultadosActivos = [];
      this.DATOS_RESULTADOS.length = 0;
      this.table.renderRows();
      this.displayedColumns = [];
    }

  }

  search() {
    this.loading = true;
    this.limpiar();
    this.obtenerCampos();
  }

  obtenerCampos() {
    if (this.tipoBuscar == "Coordenadas") {
      this.filterService.getActivos().subscribe((data1) => {
        this.activos = data1;
        this.buscarCampos(
          this.campoId,
          this.tipoBuscar,
          this.valorBuscar,
          this.valorBuscar2
        );
      });
    } else {
      this.filterService.getCampos().subscribe((data) => {
        this.campos = data;
        this.buscarCampos(
          this.campoId,
          this.tipoBuscar,
          this.valorBuscar,
          this.valorBuscar2
        );
      });
    }



  }

  buscarCampos(id: any, tipo: any, valor1: any, valor2: number) {
    switch (tipo) {
      case "Igual":
        this.campos.forEach((element: string) => {
          if (element["formulario_campo_id"] == id) {
            if (element["formulario_captura_campo_valor"] == valor1) {
              this.resultados.push(element);
            }
          }
        });
        break;

      case "Contiene":
        this.campos.forEach((element: string) => {
          if (element["formulario_campo_id"] == id) {
            if (element["formulario_captura_campo_valor"].toUpperCase().includes(valor1.toUpperCase())) {
              this.resultados.push(element);
            }
          }
        });
        break;

      case "Mayor":
        this.campos.forEach((element: string) => {
          if (element["formulario_campo_id"] == id) {
            if (Number(element["formulario_captura_campo_valor"]) > Number(valor1)) {
              this.resultados.push(element);
            }
          }
        });
        break;

      case "Menor":
        this.campos.forEach((element: string) => {
          if (element["formulario_campo_id"] == id) {
            if (element["formulario_captura_campo_valor"] < valor1) {
              this.resultados.push(element);
            }
          }
        });
        break;

      case "Intervalo":
        this.campos.forEach((element: string) => {
          if (element["formulario_campo_id"] == id) {
            if (
              element["formulario_captura_campo_valor"] > valor1 &&
              element["formulario_captura_campo_valor"] < valor2
            ) {
              this.resultados.push(element);
            }
          }
        });
        break;

      case "Coordenadas":
        this.activos.forEach((element: string) => {
          if (
            Number(element["formulario_captura_latitud"]) == Number(valor1) &&
            Number(element["formulario_captura_longitud"]) == Number(valor2)
          ) {
            this.resultados.push(element);
          }

        });
        break;

      default:
        alert("No selecciono el tipo de Busqueda");
        this.loading = false;
        break;
    }
    if (this.resultados.length == 0) {
      alert("No se encontraron coincidencias con los parametros buscados");
      this.loading = false;
      this.limpiar();
    } else {
      this.getCamposresultados();
    }

  }

  getCamposresultados() {
    this.resultados.forEach((element) => {
      this.filterService
        .getCamposResultado(element["formulario_captura_id"])
        .subscribe((data2) => {
          this.resultadosCampos.push(data2);
          this.getActivosresultados(element["formulario_captura_id"]);
        });
    });
  }

  getActivosresultados(id) {
    this.filterService
      .getActivosResultados(id)
      .subscribe((data3) => {
        this.resultadosActivos.push(data3);
        if (this.resultadosActivos.length == this.resultadosCampos.length && this.resultadosCampos.length == this.resultados.length) {
          this.generarTabla();
        }
      });
  }

  generarTabla() {
    var campo1: any, campo2: any, latitud: any, longitud: any, scene: any, sceneX: any, sceneY: any;
    var ids: any = [];
    for (let i = 0; i < this.resultados.length; i++) {
      campo2 = this.resultados[i]["formulario_captura_campo_valor"];
      longitud = Number(this.resultadosActivos[i]["formulario_captura_longitud"]).toFixed(4);
      latitud = Number(this.resultadosActivos[i]["formulario_captura_latitud"]).toFixed(4);
      sceneX = Number(this.resultadosActivos[i]["formulario_captura_x"]);
      sceneY = Number(this.resultadosActivos[i]["formulario_captura_y"]);
      scene = this.resultadosActivos[i]["formulario_captura_scene"];
      this.resultadosCampos[i].forEach(element => {
        ids.push(element["formulario_campo_id"]);
        if (element["formulario_campo_id"] == Math.min.apply(null, ids)) {
          campo1 = element["formulario_captura_campo_valor"];
          this.defCampo1 = element["formulario_campo_nombre"];
        }
        if (element["formulario_campo_id"] == this.campoId) {
          this.defCampo2 = element["formulario_campo_nombre"];
        }
      });
      const infoResultado = {
        campo1: campo1,
        campo2: campo2,
        latitud: latitud,
        longitud: longitud,
        scene: scene,
        x: sceneX,
        y: sceneY
      };
      this.DATOS_RESULTADOS.push(infoResultado);
      if (this.DATOS_RESULTADOS.length == this.resultados.length) {
        this.displayedColumns = ["campo1", "campo2", "ubicacion", "boton"];
        this.loading = false;
        this.dataSource.data = this.DATOS_RESULTADOS;

      }
    }
  }

}
export interface VistaResultados {
  campo1: string;
  campo2: string;
  latitud: number;
  longitud: number;
  scene: string;
  x: number;
  y: number;
}



